import { UA } from '@/libs/constants/device';
export function getIsIos() {
  return (
    UA.indexOf('iphone') > -1 ||
    UA.indexOf('ipad') > -1 ||
    (UA.indexOf('macintosh') > -1 && 'ontouchend' in document)
  );
}
